import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store';

const selectCmsContent = (state: RootState) => state.cmsContent;

const getCmsData = (data: any) => data?.content?.content?.elements?.element[0]?.data?.PropertiesContent?.value;

export const selectContent = (contentId: string) =>
    createSelector([selectCmsContent], data => data[contentId] && getCmsData(data[contentId]));
